module.exports = __webpack_public_path__ + "static/assets/f803a18aad32338b02b679c8de283825.gif";